import { FC, useState } from 'react';
import { Modal } from '@/components/molecule/Modal';
import { MissionHubTask } from '@/components/mission-hub/MissionHubTask';
import dynamic from 'next/dynamic';
import { MissionHubTaskV2 } from '@/utils/http/get-mission-tasks';
import { useRecoilValue } from 'recoil';
import { appPointsAtom } from '@/state/app';

const TwitterFollow = dynamic(() => import('../modals/TwitterFollow'));

interface TwitterConnectProps {
    mission: MissionHubTaskV2;
    points: number;
    signup: () => void;
    refreshPoints: () => void;
    follows: string;
}

// @ts-ignore
export const TwitterFollows: FC<TwitterConnectProps> = ({ mission, points, signup, refreshPoints, follows }) => {
    const { standingData, twitterLimit } = useRecoilValue(appPointsAtom);
    const [visible, setVisible] = useState(false);
    // @ts-ignore
    const isConnected = standingData.activities['TWITTER-Connect']?.points > 0;

    return (
        <>
            <Modal
                isVisible={visible}
                onClose={() => setVisible(false)}
                bodyPadding="p-0"
                modalWidth="w-full md:w-[32rem]"
            >
                <TwitterFollow
                    follows={follows}
                    activity={mission._id}
                    title={mission.title}
                    description={mission.description}
                    twitterConnect={isConnected}
                    signup={signup}
                    onSubmit={() => {
                        setVisible(false);
                        refreshPoints();
                    }}
                />
            </Modal>
            <MissionHubTask
                mission={mission}
                points={points}
                isDisabled={points > 0 || twitterLimit?.follow?.rate_limited}
                onClick={() => setVisible(true)}
                ctaLabel={
                    twitterLimit?.follow?.rate_limited
                        ? `Available in ${twitterLimit.follow.nextMinutes} mins`
                        : undefined
                }
            />
        </>
    );
};
